import { color } from '@upstox/upstox-ui';

export const browserName: CSSFunction = ({ theme }) => ({
  color: color(theme, 'text.link'),
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '19px',
});

export const browserList: CSSFunction = () => ({
  justifyContent: 'space-between',
  marginBottom: '48px',
  padding: '0px 24px',
  width: '100%',

  '@media screen and (max-width:768px)': {
    marginBottom: '12px',
    padding: '0px 8px',
  },
});

export const browserLogoContainer: CSSFunction = () => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',

  '& img': {
    '@media screen and (max-width:768px)': {
      height: '30px',
      width: '30px',
    },
  },
});
